


























import Vue from "vue";
import Component from "vue-class-component";
import MainFooter from "@/views/MainFooter.vue";
import MenuMdAndUp from "@/components/MenuMdAndUp.vue";
import MenuSmAndDown from "@/components/MenuSmAndDown.vue";

@Component({
  components: { MenuSmAndDown, MenuMdAndUp, MainFooter },
})
export default class MainMenu extends Vue {
  allowedRouter() {
    console.log(this.$route.fullPath);
    if (this.$route.fullPath == "/Login" || this.$route.fullPath == "/Admin") {
      return false;
    }
    return true;
  }
}
